var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "scrollList",
      staticClass: "sc-message-list",
      style: { backgroundColor: _vm.colors.messageList.bg },
      on: { scroll: _vm.handleScroll },
    },
    [
      _vm._l(_vm.filteredMessages, function (message, idx) {
        return _c(
          "Message",
          {
            key:
              "sc-message_" +
              (_vm.$_.get(message, "id") ||
                _vm.$_.get(message, "raw.uniqMessageId") ||
                idx),
            class: {
              hiddenMessage: _vm.isOwnedByRequestUser
                ? false
                : !_vm.$_.get(message, "raw.isVisible", true),
            },
            attrs: {
              id:
                "sc-message_" +
                (_vm.$_.get(message, "id") ||
                  _vm.$_.get(message, "raw.uniqMessageId") ||
                  idx),
              colors: _vm.colors,
              "is-chat-window": _vm.ischatwindow,
              "is-private-chat": _vm.isPrivateChat,
              "is-colored": _vm.isColored,
              message: message,
              "random-bg-color-with-name": _vm.randomBgColorWithName,
              showAvatar: _vm.showAvatar,
              user: _vm.profile(message),
              "disable-translation": _vm.disableTranslation,
              "is-whatsapp": _vm.isWhatsapp,
              "channel-id": _vm.channelId,
              contextMenu:
                _vm.$_.get(message, "raw.isVisible", _vm.contextMenuVisable) &&
                _vm.contextMenuVisable,
              "context-menu-only-create-task": _vm.contextMenuOnlyCreateTask,
              "user-message-color": _vm.computedUserMessageColor,
              debugModeEnabled: _vm.debugModeEnabled,
              visitorId: _vm.visitorId,
            },
            on: {
              remove: function ($event) {
                return _vm.$emit("remove", message)
              },
              "reply-comment-action": function ($event) {
                return _vm.$emit("reply-comment-action", $event)
              },
              "open-gallery": _vm.handleOpenGallery,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "user-avatar",
                  fn: function (scopedProps) {
                    return [
                      _vm._t("user-avatar", null, {
                        message: scopedProps.message,
                        user: scopedProps.user,
                      }),
                    ]
                  },
                },
                {
                  key: "text-message-body",
                  fn: function (scopedProps) {
                    return [
                      _vm._t("text-message-body", null, {
                        me: scopedProps.me,
                        message: scopedProps.message,
                        messageColors: scopedProps.messageColors,
                        messageText: scopedProps.messageText,
                      }),
                    ]
                  },
                },
                {
                  key: "text-message-toolbox",
                  fn: function (scopedProps) {
                    return [
                      _vm._t("text-message-toolbox", null, {
                        me: scopedProps.me,
                        message: scopedProps.message,
                      }),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          },
          [_vm._v("\n        " + _vm._s(message) + "\n        ")]
        )
      }),
      _vm._v(" "),
      _vm.newMsg && _vm.ischatwindow
        ? _c(
            "div",
            { staticClass: "newMsg", on: { click: _vm._scrollDown } },
            [_c("md-icon", [_vm._v("expand_more")])],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("ChatMediaGallery", {
        attrs: {
          visible: _vm.galleryVisible,
          items: _vm.galleryItemsForOverlay,
          "initial-index": _vm.initialGalleryIndex,
          "show-go-to-message": true,
        },
        on: {
          "update:visible": function ($event) {
            _vm.galleryVisible = $event
          },
          "go-to-message": _vm.onGalleryGoToMessage,
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }